import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { BladeCal } from '@/constants/blade';

export default function CalculatorInit({ callBack, calObj }: any) {
    const { useLang, gtm, Link } = useGlobal();
    const { t } = useLang('bladecalculator');
    const handleCallback = () => {
        callBack({ ...calObj, currentPage: BladeCal.Step1 });
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_interact_button',
            product_name: 'EcoFlow BLADE',
            list_name: 'Start',
            button_name: 'Start',
        });
    };
    return (
        <div className={`calculator-init ${css.calculatorInit}`}>
            <Link className="modal-close" href={'/blade-robotic-lawn-mower'}>
                &times;
            </Link>
            <p className="modal-title">{t('detail.calculator_modal_title')}</p>
            <p className="modal-text">{t('detail.calculator_modal_text')}</p>
            <button className="modal-btn" onClick={handleCallback}>
                {t('detail.calculator_modal_btn')}
            </button>
        </div>
    );
}
